// src/components/BackgroundVectors.js
import React from "react";

// These are the same assets the Home page uses.
// If your images live elsewhere, adjust the paths accordingly.
import tlvec from "../assets/images/topleftvec.png";
import trvec from "../assets/images/toprightvec.png";
import rvec  from "../assets/images/rightvec.png";
import lvec  from "../assets/images/leftvec.png";

export default function BackgroundVectors({ shift = 0 }) {
  return (
    // Decorative only; keep it out of the accessibility tree.
    <div
      className="bg-vectors"
      aria-hidden="true"
      style={{ "--bg-shift": `${shift}px` }}  // CSS var consumed by Organizers.css
    >
      <img className="tlvec" src={tlvec} alt="" loading="lazy" decoding="async" draggable="false" />
      <img className="trvec" src={trvec} alt="" loading="lazy" decoding="async" draggable="false" />
      <img className="rvec"  src={rvec}  alt="" loading="lazy" decoding="async" draggable="false" />
      <img className="lvec"  src={lvec}  alt="" loading="lazy" decoding="async" draggable="false" />
    </div>
  );
}
